'use strict';

module.exports = {
  TRANSFORM_TYPE_FIT: 'fit',
  TRANSFORM_TYPE_FILL: 'fill'
};